import { h, Component } from 'preact'
import styled, { css } from 'styled-components'
import { screenLessThan930 } from '../../media'
import flagEn from './flag-en.png'

const EnText = styled(p => <div {...p}>EN</div>)`
  position: absolute;
  left: 0;
  line-height: 42px;
  width: 60px;
  opacity: 0;
  pointer-events: none;
  width: 60px;
  text-align: center;
`

export default styled(
  class LanguageSwitcher extends Component {
    render() {
      return (
        <a href="/en" {...this.props}>
          <EnText />
        </a>
      )
    }
  },
)`
  position: fixed;
  right: 0;
  top: 22px;
  z-index: 3000;
  background: #039 url(${flagEn}) right 0 no-repeat;
  width: 42px;
  height: 42px;
  color: white;

  :hover {
    width: 100px;
    background-position: right -42px;
  }

  :hover ${EnText} {
    opacity: 1;
    pointer-events: all;
  }

  ${screenLessThan930(css`
    display: none;
  `)};
`



// WEBPACK FOOTER //
// ./components/layout/Header/LanguageSwitcher.js